import axios from "axios";

const headers = { "Content-Type": "application/json" };
if (localStorage.getItem('jwtToken')) {
  headers.Authorization = localStorage.getItem('jwtToken');
}
const instance = axios.create({
  baseURL: process.env.VUE_APP_PHP_FRONT_END_API_BASE_URL,
  //baseURL: "http://localhost:8000/api/v1/",
  headers: headers,
  validateStatus: (status) => true,
  timeout: 30 * 1000 * 60,
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("jwtToken");
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});

// instance.defaults.timeout = 1800000;

export default instance;
